import AwardsList from '@/components/awards/AwardsList'
import styles     from './ProjectsAwwards.module.sass'

const classNames = {
	section: styles['projects-awards'],
	title:   styles['projects-awards__title'],
	items:   styles['projects-awards__items'],
	item:    styles['projects-awards-item'],
	site:    styles['projects-awards-item__site'],
	award:   styles['projects-awards-item__award'],
}

const ProjectsAwwards = ({title, data}) => (
	<AwardsList
		title={title}
		data={data}
		classNames={classNames}
	/>
)

export default ProjectsAwwards
